export const featureFlagsStoreKey = 'featureFlags';
